var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.302,
    height: 34.417,
    viewBox: "0 0 31.302 34.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7798",
    "data-name": "Path 7798",
    d: "M32.115,8.438c-5.386-.534-10.8-.809-16.207-.809A95.544,95.544,0,0,0,6.3,8.114L3,8.438M11.9,6.8l.356-2.119C12.511,3.148,12.705,2,15.439,2h4.238c2.734,0,2.944,1.213,3.186,2.7l.356,2.1M29.19,8.438l-1.6,21.4c-.178,2.539-.324,4.513-4.836,4.513H12.365c-4.513,0-4.658-1.973-4.836-4.513L6.3,8.114m7.01-.485L14.56,34.35M21.49,8.114,19.676,34.35",
    transform: "translate(-1.907 -1)",
    fill: "none",
    stroke: "#023f7f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.2edab5cc81556d291dd0161738ba70fb.svg";
export { ForwardRef as ReactComponent };